import { TJsonQuery } from '../../../../packages/JsonQuery';
import { ResponseError } from '../../errors';
import { IV2MapGetBBoxResponseSchema } from '../../repositories/search-offers-index/entities/get_bbox/V2MapGetBBoxResponseSchema';
import { fetchMapGetBbox, TMapGetBboxResponse } from '../../repositories/search-offers-index/v2/map/get-bbox';
import { IApplicationContext } from '../../types/applicationContext';

interface IFetchGeoBboxParameters {
  jsonQuery: TJsonQuery;
  subdomain: string;
}

/**
 * Лёгкий запрос области гео (bbox) по jsonQuery — без поиска офферов. Используется
 * для фокусировки карты при смене гео из фильтров (см. applyGeoChange).
 * SSR-аналог — resolveBbox (та же ручка, но вход — URL и есть DEFAULT_BBOX-фолбэк).
 */
export async function fetchGeoBbox(
  context: IApplicationContext,
  { jsonQuery, subdomain }: IFetchGeoBboxParameters,
): Promise<IV2MapGetBBoxResponseSchema> {
  const { httpApi, cancellationTokenManager } = context;

  const abortSignal = cancellationTokenManager?.getSignalAndCancelPrevious('fetchGeoBbox');

  const response: TMapGetBboxResponse = await fetchMapGetBbox({
    httpApi,
    parameters: { jsonQuery, subdomain },
    config: { signal: abortSignal },
  });

  if (response.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchGeoBbox',
      message: response.response.message || '',
    });
  }

  return response.response;
}
